import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "abs-center"
}
const _hoisted_2 = ["src"]

import { ref, PropType } from "vue";
import { hideToast } from ".";
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  // 弹框类型
  type: {
    type: String as PropType<"success" | "error" | "loading" | 'none'>,
    default: "success",
  },
  // 蒙层框多少秒之后关闭
  time: {
    type: Number,
    default: 1.5,
  },
  content: {
    type: String,
  },
  icon: {
    type: String,
  },
},
  setup(__props) {

const props = __props
// const visiable = ref(true);
const toastContent = ref("");
const toastIcon = ref("");

if (props.time && props.type !== 'loading') {
  setTimeout(() => {
    // visiable.value = false;
    hideToast()
  }, props.time * 1000);
}

const { t } = useI18n();

const choostType: Map<string, { icon: string; content: string }> = new Map([
  [
    "success",
    {
      icon: require("@/assets/img/success.png"),
      content: t('common.success'),
    },
  ],
  [
    "error",
    {
      icon: require("@/assets/img/error.png"),
      content: t('common.fail'),
    },
  ],
  [
    "loading",
    {
      icon: require("@/assets/img/loading.gif"),
      content: t('common.loading'),
    },
  ],
  [
    "none",
    {
      icon: '',
      content: "",
    },
  ],
]);
let obj: any = choostType.get(props.type);
toastIcon.value = props.icon || obj.icon;
toastContent.value = props.content || obj.content;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "toast-box",
    onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["toast abs-center", { 'have-icon': __props.type != 'none' }])
    }, [
      (__props.type == 'success' || __props.type == 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (toastIcon.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: toastIcon.value
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(toastContent.value), 1)
    ], 2)
  ], 32))
}
}

})